import { containsSpecialChars } from '@utils/cart.utils';
import { EMAIL_REGEX, PHONE_REGEX } from '../constants';

export const hasFirstNameOrLastNameMinimumLengthError = (str: string) => str !== '' && str.length < 3;

export const hasFirstNameOrLastNameContainsSpecialCharactersError = (str: string) =>
    str !== '' && containsSpecialChars(str);

export const hasIncorrectEmail = (str: string) => str === '' || !EMAIL_REGEX.test(str);

export const hasIncorrectPhone = (str: string) => str === '' || !PHONE_REGEX.test(str);
